/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const RewardActive = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="18" height="18" rx="1" />
        <path d="M12.7884402,0.711663296 C13.2824203,1.20564339 12.8817698,2.40626169 11.8944762,3.39422188 C10.906516,4.38218207 9.70523108,4.78216596 9.21125098,4.28818586 C8.71793753,3.7948724 9.11792141,2.59358747 10.1058816,1.60629392 C11.0938418,0.617667084 12.2944601,0.217683199 12.7884402,0.711663296 Z" stroke="#00ADEE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.21155981,0.711663296 C4.71757972,1.20564339 5.11823024,2.40626169 6.10552379,3.39422188 C7.09348399,4.38218207 8.29476892,4.78216596 8.78874902,4.28818586 C9.28206247,3.7948724 8.88207859,2.59358747 7.8941184,1.60629392 C6.9061582,0.617667084 5.70553991,0.217683199 5.21155981,0.711663296 Z" stroke="#00ADEE" strokeLinecap="round" strokeLinejoin="round" />
        <rect stroke="#00ADEE" strokeLinejoin="round" x="3.49988891" y="4.49988891" width="10.997556" height="10.997556" />
        <rect fill="#00ADEE" x="3" y="9.49877798" width="11.9973338" height="1" rx="0.5" />
        <rect fill="#00ADEE" x="8.49877798" y="4" width="1" height="11.9973338" rx="0.5" />
      </g>
    </BaseSvgIcon>
  )
}

export default RewardActive
